import type { SVGProps } from "react";
export interface SpaIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SpaIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SpaIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.487 11.027c1.453-.871 3.39-1.622 5.744-1.128.52.11.893.57.893 1.101 0 3.278-1.176 6.076-3.194 8.054-2.015 1.974-4.806 3.07-7.93 3.07s-5.915-1.095-7.93-3.07C2.05 17.076.875 14.278.875 11c0-.532.373-.992.894-1.101 2.353-.495 4.29.257 5.743 1.128l.592.376.092.069a1.125 1.125 0 0 1-1.248 1.857l-.1-.058-.496-.318c-.944-.566-1.994-.982-3.185-.96.206 2.268 1.118 4.122 2.478 5.454C7.2 18.972 9.41 19.874 12 19.874s4.798-.902 6.354-2.427c1.36-1.332 2.27-3.186 2.476-5.454-1.404-.026-2.611.559-3.68 1.278l-.098.058a1.125 1.125 0 0 1-1.158-1.926z"
      />
      <path
        fill={color}
        d="M12.624 21.936c-.378.252-.87.252-1.248 0L12 21zm2.751-9.435c0-2.428-.99-4.315-2.011-5.62A11 11 0 0 0 12 5.434c-.376.33-.87.816-1.364 1.447-1.02 1.305-2.011 3.192-2.011 5.62 0 2.426.99 4.314 2.011 5.619.494.63.989 1.114 1.364 1.444.375-.33.87-.814 1.364-1.444 1.02-1.305 2.01-3.193 2.011-5.62Zm2.25 0c0 3.072-1.26 5.434-2.489 7.004a13 13 0 0 1-1.695 1.789 11 11 0 0 1-.74.589l-.052.036q-.01.007-.016.01l-.005.005-.002.002L12 21l-.626.936-.002-.002q-.002-.001-.005-.004l-.016-.01-.051-.037q-.064-.044-.17-.125a11 11 0 0 1-.571-.464 13 13 0 0 1-1.695-1.789c-1.23-1.57-2.489-3.932-2.489-7.004 0-3.073 1.26-5.436 2.489-7.007a13 13 0 0 1 1.695-1.788 11 11 0 0 1 .74-.59l.052-.034.016-.012.005-.003.002-.002v-.001s.002 0 .43.642l-.428-.642c.378-.252.87-.252 1.248 0L12 4c.624-.936.625-.936.626-.936v.001l.002.002q.002 0 .005.003l.016.012.051.035q.064.044.17.124c.142.107.339.262.571.465a13 13 0 0 1 1.695 1.788c1.23 1.57 2.489 3.934 2.489 7.007"
      />
    </svg>
  );
}
